import "./App.css";
import AdvisedLearning from "./htbd/AdvisedReading.compoonent";
import EvaluationCriteria from "./htbd/EvaluationCriteria.component";
import Footer from "./htbd/Footer.component";
import Goal from "./htbd/Goal.component";
import Grading from "./htbd/Grading.component";
// import Header from "./htbd/Header.component";
import Header from "./global/Header";
import OurPolicy from "./htbd/OurPolicy.component";
import ProvideEvidence from "./htbd/ProvideEvidence.component";
import Slider from "./htbd/Slider.component";
import Weeks from "./htbd/Weeks.component";
import YourLearning from "./htbd/YourLearning.component";

function App() {
  return (
    <div className="bg-dark">
    <div className="position-relative" style={{ zIndex: '3'}}>
      <Header />
    </div>
     <main className="position-relative" style={{ zIndex: '2'}}>
      <Slider />
      <Goal />
      <Weeks />
      <YourLearning />
      <EvaluationCriteria />
      <ProvideEvidence/>
      <Grading />
      <AdvisedLearning />
     </main>
     <OurPolicy/>
     <Footer/>
    </div>
  );
}

export default App;
